import { imprimirRetiradaMercadoria } from 'modulo-gerencial-erp-pacotes-impressora-termica';

import { imprimirServicoNovo, buscarDadosImpressao } from '../utils';

async function imprimir(id, query = '', usar_nova_impressao = false) {
  /* if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 7, query);
  }

  const dados = await buscarDadosImpressao(id, 7);

  const { comandos } = layout(adapter(dados));

  const response = await imprimirServicoNovo(
    id,
    'retirada-mercadoria',
    comandos,
  );
  return response.data; */

  return await imprimirRetiradaMercadoria({
    id,
    buscarDadosImpressao,
    chamarServicoImpressoraTermica: imprimirServicoNovo,
    query: '',
  });
}

export default imprimir;
